import { TlfArsMasterReadDto, TlfItemReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { applyVariantPatches } from "functions/tlf/applyVariantPatches";
import { buildVariantPatch } from "functions/tlf/buildVariantPatch";
import { getVariantPatchContext } from "./getVariantPatchContext";
import { TlfContextProps } from "./interface";

/**
 * Builds the persisted master and composed editor view without mutating variant selection.
 *
 * @param state - Editor state containing the baseline master and selected variant patches.
 * @param tlf - Loaded TLF to persist when variant editing is inactive.
 * @returns Save payload and optional variant view, or null when selected patches cannot compose.
 */
export const prepareTlfSave = (
  state: TlfContextProps,
  tlf: TlfItemReadDto,
): { tlfItem: TlfItemReadDto; variantView?: TlfItemReadDto } | null => {
  if (!state.variantCreationView && state.appliedVariantPatches.length === 0)
    return { tlfItem: tlf };
  const { currentMaster, master } = getVariantPatchContext(state);
  if (!currentMaster || !master) return null;
  const patchCatalog = { ...currentMaster.allVariantPatches };
  const masterToSave: TlfArsMasterReadDto = {
    ...master,
    allVariantPatches: patchCatalog,
    variantTemplates: currentMaster.variantTemplates,
  };
  if (state.activeVariantPatchName !== null) {
    const base = applyVariantPatches(
      masterToSave,
      masterToSave,
      state.appliedVariantPatches.filter((name) => name !== state.activeVariantPatchName),
    );
    if (!base.success) return null;
    patchCatalog[state.activeVariantPatchName] = buildVariantPatch(base.data, currentMaster).patch;
  }
  const currentView = applyVariantPatches(masterToSave, masterToSave, state.appliedVariantPatches);
  return currentView.success ? { tlfItem: masterToSave, variantView: currentView.data } : null;
};
